import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Shredder = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 27C26 27.552 25.552 28 25 28C24.448 28 24 27.552 24 27C24 26.448 24.448 26 25 26C25.552 26 26 26.448 26 27Z" />
		<path d="M8 27C8 27.552 7.552 28 7 28C6.448 28 6 27.552 6 27C6 26.448 6.448 26 7 26C7.552 26 8 26.448 8 27Z" />
		<path d="M20 25C20 25.552 19.552 26 19 26C18.448 26 18 25.552 18 25C18 24.448 18.448 24 19 24C19.552 24 20 24.448 20 25Z" />
		<path d="M24 15C24 15.552 23.552 16 23 16C22.448 16 22 15.552 22 15C22 14.448 22.448 14 23 14C23.552 14 24 14.448 24 15Z" />
		<path d="M28 15C28 12.585 26.279 10.565 24 10.101V7C24 5.346 22.654 4 21 4H11C9.346 4 8 5.346 8 7V10.101C5.72 10.565 4 12.586 4 15C4 16.632 4.787 18.084 6 18.997C6 18.998 6 18.999 6 19V23C6 23.552 6.448 24 7 24C7.552 24 8 23.552 8 23V19.899C8.323 19.965 8.658 20 9 20H12V25C12 25.552 12.448 26 13 26C13.552 26 14 25.552 14 25V20H18V21C18 21.552 18.448 22 19 22C19.552 22 20 21.552 20 21V20H23C23.342 20 23.677 19.965 24 19.899V23C24 23.552 24.448 24 25 24C25.552 24 26 23.552 26 23V19C26 18.999 26 18.998 26 18.997C27.214 18.084 28 16.632 28 15ZM11 6H21C21.551 6 22 6.449 22 7V10H10V7C10 6.449 10.449 6 11 6ZM23 18H9C7.346 18 6 16.654 6 15C6 13.346 7.346 12 9 12H23C24.654 12 26 13.346 26 15C26 16.654 24.654 18 23 18Z" />
	</svg>
);

export default Shredder;
